import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import InvoiceLineItemForm from '../../../components/forms/InvoiceLineItemForm';
import { useInvoiceLineItemApi } from '../../../hooks/useInvoiceLineItemApi';
import { useNavigate, useParams } from 'react-router-dom';
import { InvoiceLineItemDTO } from '../../../services/apiClient';

const InvoiceLineItemEdit: React.FC = () => {
  const { getById, edit } = useInvoiceLineItemApi();
  const [entityData, setEntityData] = useState<InvoiceLineItemDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Invoice Line Items', href: '/admin/invoicelineitems' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching InvoiceLineItem data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/invoicelineitems');
    } catch (error) {
      console.error('Error updating InvoiceLineItem:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/invoicelineitems"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.InvoiceLineItem.Edit'
    >
        {entityData ? (
          <InvoiceLineItemForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/invoicelineitems')}
            isLoading={isSubmitting}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default InvoiceLineItemEdit;